module.exports = __webpack_public_path__ + "static/img/PS.c1aeb9f4.svg";